import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import apiConfig from "config/api";
import tokenService from "services/auth/tokenService";
import {
    addMessage,
    setSignalRStatus,
    setCurrentUserId
} from "features/Messages/dataStore/messageSlice";
import store from "app/store";

const connection = new HubConnectionBuilder()
    .withUrl(`${apiConfig.baseUrl}/hubs/app`, {
        accessTokenFactory: () => tokenService.getToken()
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Information)
    .build();

connection.onreconnecting((error) => {
    console.log("SignalR reconnecting...", error);
    store.dispatch(setSignalRStatus("Reconnecting"));
});

connection.onreconnected((connectionId) => {
    console.log("SignalR reconnected:", connectionId);
    store.dispatch(setSignalRStatus("Connected"));
});

connection.onclose((error) => {
    console.log("SignalR disconnected:", error);
    store.dispatch(setSignalRStatus("Disconnected"));
});

connection.on("UserMessage", (data) => {
    console.log("Received user message:", data);
    store.dispatch(addMessage(data));
});

window.signalRConnection = connection;

export const startSignalR = async () => {
    if (connection.state === "Connected") {
        console.log("SignalR already connected");
        return;
    }

    try {
        await connection.start();
        console.log("SignalR connected");
        store.dispatch(setSignalRStatus("Connected"));

        const userId = await connection.invoke("GetMyUserId");
        store.dispatch(setCurrentUserId(userId));
        console.log("SignalR User ID:", userId);
    } catch (error) {
        console.error("SignalR connection failed:", error);
        store.dispatch(setSignalRStatus("Disconnected"));
    }
};

// Centralized send helper so components don't call connection.invoke directly
export const sendMessageToUsers = async (userIds, payload) => {
    if (connection.state !== "Connected") {
        throw new Error("Cannot send message: SignalR is not connected");
    }
    return connection.invoke("SendMessageToUsers", userIds, payload);
};

export default connection;
